import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { isSmScreen } from '@client/helpers/screens';
import { getCookie } from '@client/helpers/cookie';
import { USABILLA_COOKIE } from '@browsing/usabilla';

export const useDealsMyLoungeSurvey = () => {
    const { pathname } = useLocation();
    const [dealsMyLoungeSurveyTrigger, setDealsMyLoungeSurveyTrigger] = useState(0);
    const [scrollGreaterThan1000, setScrollGreaterThan1000] = useState(false);
    const [timeOnPageMet, setTimeOnPageMet] = useState(false);
    const [usabillaAlreadyShown, setUsabillaAlreadyShown] = useState(false);

    const isMyloungePage = pathname?.includes('/event');

    const shouldSkipSurvey =
        !isMyloungePage || usabillaAlreadyShown || dealsMyLoungeSurveyTrigger === 1;

    useEffect(() => {
        setUsabillaAlreadyShown(getCookie(USABILLA_COOKIE) === 'true');
    }, [pathname]);

    useEffect(() => {
        setDealsMyLoungeSurveyTrigger(0);
        setScrollGreaterThan1000(false);
        setTimeOnPageMet(false);
    }, [pathname]);

    useScrollPosition(
        ({ currPos }) => {
            if (shouldSkipSurvey || scrollGreaterThan1000) {
                return;
            }
            const scrollY = Math.abs(currPos.y);
            if (scrollY > 1000) {
                setScrollGreaterThan1000(true);
            }
        },
        [shouldSkipSurvey, scrollGreaterThan1000],
        undefined,
        true,
    );

    useEffect(() => {
        if (shouldSkipSurvey) {
            return;
        }

        const isMobile = isSmScreen(window.innerWidth);
        const timeThreshold = isMobile ? 15000 : 30000; // 15 seconds mobile, 30 seconds desktop

        const timer = setTimeout(() => {
            setTimeOnPageMet(true);
        }, timeThreshold);

        return () => clearTimeout(timer);
    }, [shouldSkipSurvey, pathname]);

    useEffect(() => {
        if (shouldSkipSurvey) {
            return;
        }

        if (scrollGreaterThan1000 && timeOnPageMet) {
            setDealsMyLoungeSurveyTrigger(1);
        }
    }, [shouldSkipSurvey, scrollGreaterThan1000, timeOnPageMet]);

    return dealsMyLoungeSurveyTrigger;
};
